import { Field, ObjectType } from "./decorators";

export interface EtlResult {
  details: string[];
  severity: string;
  description: string;
}
export interface EtlDetails {
  cloudWatchUrl: string;
  date: string;
  stage: string;
  results: EtlResult;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  taskResults: any;
}


export interface AuditAnomaly {
  status: string;
  values: (number|string)[];
}
export interface AuditDetails {
  stage: string;
  subject: string;
  auditName: string;
  timestamp: string;
  anomalies: AuditAnomaly[];
  columnHeaders: string[];
}


export interface ResultDetailService {
  name: string;
  serviceMonitorName: string;
  outageCriticality: number;
}
export interface ResultDetail {
  startDateTime: Date;
  endDateTime: Date;
  status: string;
  condition: number;
  message: string;
  service: ResultDetailService;
}
export interface ResMonDetails {
  stage: string;
  region: string;
  startDateTime: Date;
  endDateTime: Date;
  overallState: number;
  results: ResultDetail[];
}

export interface TaskResultData {
  key: string;
  count: number;
}
export interface TaskResult {
  status: string;
  details: {
    start: string; // ISO date.
    end: string; // ISO date.
    data: TaskResultData[];
  }
}

export interface TacDetails {
  cloudWatchUrl: string;
  date: string; // YYYY-MM-DD
  stage: string;
  results: Record<string, TaskResult>;
}

@ObjectType()
export class InternalActivity {
  @Field() activityId!: number;
  @Field() activityType!: string;
  @Field() region!: string;
  @Field() startTime!: Date;
  @Field() endTime!: Date;
  @Field() status!: string;
  @Field() details?: AuditDetails | EtlDetails | ResMonDetails | TacDetails;
  @Field() acknowledged?: boolean;
  @Field() acknowledgedBy?: string;
  @Field() acknowledgedTime?: Date;
  @Field() acknowledgementNotes?: string;
  @Field() occurrences!: number;
}



@ObjectType()
export class AvailableResult {
  @Field() timestamp!: string;
  @Field() overallState!: number;
}